module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-54373363692cff37a93f4c769275dc5c.png";